const styles = {
  image: {
    width: 150,
    height: 150,
  },
  chip: {
    alignSelf: 'flex-end',
  },
  popper: {
    zIndex: 9999,
  },
  paper: {
    height: '60vh',
    width: '50vw',
    p: 2,
    backgroundColor: 'grey.100',
    display: 'flex',
    flexDirection: 'column',
  },
};

export default styles;
